import { Translation } from 'hooks/useTranslation/useTranslation';
import { FilterSection } from 'v2/components/SearchAndFilters/SearchAndFilters';
import { filterAccessDefault } from './userGroupFilterConstants';
import { FilterOfficeMode, UserGroupFilterState } from './userGroupFilterTypes';

interface Params {
  translation: Translation;
  filters: UserGroupFilterState;
}

export const createUserGroupFilterSections = ({ translation, filters }: Params): FilterSection[] => {
  const { filterAccess, filterOfficeMode } = filters.filter;
  const { setFilterAccess, setFilterOfficeMode } = filters.setters;

  return [
    {
      id: 'access',
      header: translation.access,
      type: 'checkbox',
      items: [
        {
          key: 'noUsers',
          label: translation.no_users,
          checked: filterAccess.noUsers,
          onChange: () =>
            setFilterAccess((current) => ({
              ...current,
              noUsers: !current.noUsers
            }))
        },
        {
          key: 'noSchedule',
          label: translation.no_schedule,
          checked: filterAccess.noSchedule,
          onChange: () =>
            setFilterAccess((current) => ({
              ...current,
              noSchedule: !current.noSchedule
            }))
        },
        {
          key: 'noDevices',
          label: translation.no_devices,
          checked: filterAccess.noDevices,
          onChange: () =>
            setFilterAccess((current) => ({
              ...current,
              noDevices: !current.noDevices
            }))
        }
      ],
      isClearDisabled: !Object.values(filterAccess).some(Boolean),
      onClear: () => setFilterAccess(filterAccessDefault)
    },
    {
      id: 'office_mode',
      header: translation.office_mode,
      type: 'radio',
      items: [
        {
          key: FilterOfficeMode.Allowed,
          label: translation.allowed,
          checked: filterOfficeMode === FilterOfficeMode.Allowed,
          onChange: () => setFilterOfficeMode(FilterOfficeMode.Allowed)
        },
        {
          key: FilterOfficeMode.NotAllowed,
          label: translation.not_allowed,
          checked: filterOfficeMode === FilterOfficeMode.NotAllowed,
          onChange: () => setFilterOfficeMode(FilterOfficeMode.NotAllowed)
        }
      ],
      isClearDisabled: filterOfficeMode === null,
      onClear: () => setFilterOfficeMode(null)
    }
  ];
};
